import React from 'react';
import {
  Box,
  Card, CardContent, createStyles,
  makeStyles,
  Typography,
} from '@material-ui/core';
import type { IRepairCardDetailProps } from './RepairCostInterfaces';

const useStyles = makeStyles(() => createStyles({
  estimatorCard: {
    height: '100%',
  },
  estimatorSvg: {
    height: 24,
    width: 24,
    marginBottom: 7,
  },
}));

const RepairCostDetailsCard: React.FC<IRepairCardDetailProps> = (
  { repairId },
) => {
  const classes = useStyles();

  return (
    <Card className={classes.estimatorCard}>
      <CardContent>
        <Typography>{'Current Repair'}</Typography>
        <Typography variant="h4" className="verticalCenter">
          <Box component="span" mr={1}>{repairId}</Box>
        </Typography>
        <Typography variant="caption" color="textSecondary">{'Repair ID'}</Typography>
      </CardContent>
    </Card>
  );
};

export default RepairCostDetailsCard;
